import { getUser, getToken, getQrApiKey } from "../../Utilities/Common";
import {
  postQrAPICallwithFile,
  getQrWithParamsAPICall,
} from "../axiosMethodCall";

//POST API -- append a new data to the db
export const createQrPatient = async (info, is_vip) => {
  try {
    var formData = new FormData();
    formData.append("api_key", getQrApiKey());
    formData.append("added_by", info.added_by);
    formData.append("first_name", info.first_name || "");
    formData.append("middle_name", info.middle_name || "");
    formData.append("last_name", info.last_name || "");
    formData.append("birthdate", info.birthdate);
    formData.append("contact_no", info.phone_no || "");
    formData.append("email", info.email || "");
    formData.append("gender", info?.patient_sex === "male" ? "Male" : "Female");
    formData.append("address", info.patient_address || "");
    formData.append("remarks", "emr");
    formData.append("origin", "emr");
    formData.append("emr_patient_id", info.patient_id);
    formData.append("last_meal", info.last_meal || "");
    formData.append("senior_id", info.senior_id | "");
    formData.append("pwd_id", info.pwd_id || "");
    formData.append("is_vip", is_vip || "");
    formData.append("service_location", "clinic");
    formData.append("result", info.result || "");

    const response = await postQrAPICallwithFile(
      process.env.REACT_APP_LINK_QR + "customers/create",
      formData
    );

    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};
export const updateQrPatient = async (info) => {
  try {
    var formData = new FormData();
    formData.append("api_key", getQrApiKey());
    formData.append("origin", "emr");
    formData.append("updated_by", getUser());

    // Append data from the 'data' parameter to the formData object
    for (const [key, value] of Object.entries(info)) {
      formData.append(key, value);
    }

    const response = await postQrAPICallwithFile(
      process.env.REACT_APP_LINK_QR + "customers/update_emr",
      formData
    );

    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};
//POST API -- append a new data to the db
export const createQrBooking = async (info, id, diag) => {
  try {
    var formData = new FormData();
    formData.append("api_key", getQrApiKey());
    formData.append("requester", getUser());
    formData.append("added_by", info.added_by);
    formData.append("customer", id);
    formData.append("booking_time", info.diagnostic_date);
    formData.append("result", "email");
    formData.append("origin", "emr");
    formData.append("assessment_id", info.id);

    diag.forEach((lab) => {
      formData.append("lab_tests[]", lab.id || null);
      formData.append("lab_prices[]", 0);
    });
    // info.diagnostic_packages.forEach((lab) => {
    //   formData.append("package_tests[]", lab.package_id || null);

    // });

    formData.append("type", "clinic");

    const response = await postQrAPICallwithFile(
      process.env.REACT_APP_LINK_QR + "bookings/create_emr",
      formData
    );

    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};
//POST API -- append a new data to the db
export const getQrResults = async (id, lab_id) => {
  try {
    var payload = {
      api_key: getQrApiKey(),
      origin: "emr",
      customer_id: id,
      lab_test_id: lab_id,
    };

    const response = await getQrWithParamsAPICall(
      process.env.REACT_APP_LINK_QR + "bookings/emr_patient_results",
      payload
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const searchCustomer = async (info) => {
  try {
    var payload = {
      api_key: getQrApiKey(),
      requester: getUser(),
      token: getToken(),
      patient_no: info?.patient_no || "",
      last_name: info?.last_name || "",
      birthdate: info?.birthdate || "",
    };

    const response = await getQrWithParamsAPICall(
      process.env.REACT_APP_LINK_QR + "customers/search_record",
      payload
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const getLabtestQR = async (info) => {
  try {
    var payload = {
      api_key: getQrApiKey(),
      requester: getUser(),
      token: getToken(),
      term: info?.term || "",
    };

    const response = await getQrWithParamsAPICall(
      process.env.REACT_APP_LINK_QR + "lab_tests/getAll",
      payload
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const getLabCategoriesQR = async (info) => {
  try {
    var payload = {
      api_key: getQrApiKey(),
      requester: getUser(),
      token: getToken(),
      origin: "emr",
      category_id: info?.category_id || "",
    };

    const response = await getQrWithParamsAPICall(
      process.env.REACT_APP_LINK_CSR + "categories/get_parent",
      payload
    );
    return response;
  } catch (error) {
    return error;
  }
};
